<template>
	<div class="renewal-record">
		<search-recharge-record
			v-on:resetSearch="resetSearch"
			v-on:onSubmit="onSubmit"
			:payTypeList="renewalPayTypeList"
			:rentStateList="rentStateList"
			:search="search"
		>
		</search-recharge-record>
		<user-recharge
			:stepsActive="active"
			:process="process"
			:state="state"
			:orderId="orderId"
			:confirmRenew="confirmRenew"
			v-on:cancelRecharge="cancelRecharge"
			:dialogRecharge="dialogRecharge"
			:nickName="nickName"
			:price="localprice"
		>
		</user-recharge>
		<confirm-recharge
			v-on:cancel="cancel"
			:dialogRenew="dialogRenew"
			:confirmRenew="confirmRenew"
		>
		</confirm-recharge>
		<div class="vue-padding radius">
			<el-table
				v-loading="loading"
				:empty-text="$t('common.noData')"
				:element-loading-text="$t('common.loading')"
				:data="renewalRecordList"
				style="width: 100%"
				max-height="638"
				:border="true"
			>
				<el-table-column
					prop="userName"
					:label="$t('rechargeRecord.userName')"
					:show-overflow-tooltip="true"
					width="200"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="orderNumber"
					:label="$t('rechargeRecord.orderNumber')"
					width="170"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="payAccount"
					:label="$t('rechargeRecord.rechargeAccount')"
					width="170"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="price"
					:label="$t('rechargeRecord.price')"
					:formatter="priceMatter"
					width="140"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="state"
					:label="$t('rechargeRecord.state')"
					:formatter="rechargeStatus"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="payType"
					:label="$t('rechargeRecord.payType')"
					:formatter="renewalPayType"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="createTime"
					:label="$t('rechargeRecord.createTime')"
					:align="'center'"
				></el-table-column>
				<el-table-column
					fixed="right"
					:label="$t('common.operate')"
					:width="$i18n.locale == 'zh_CN' ? 195 : 280"
					:align="'center'"
				>
					<template slot-scope="scope">
						<template v-if="scope.row.state !== 5">
							<el-button
								type="primary"
								size="mini"
								v-hasPerm="['renewal:record:update']"
								@click="nextStep(scope.row)"
							>
								{{ $t("rechargeRecord.details") }}
							</el-button>
							<el-button
								type="danger"
								size="mini"
								v-if="scope.row.state === 0"
								v-hasPerm="['renewal:record:revoke:renew']"
								@click="revoke(scope.row)"
							>
								{{ $t("rechargeRecord.revoke") }}
							</el-button>
							<el-button
								type="warning"
								size="mini"
								v-hasPerm="['renewal:record:renew']"
								v-if="scope.row.state === 1"
								@click="renew(scope.row)"
							>
								{{ $t("rechargeRecord.renew") }}
							</el-button>
						</template>
						<template v-else>
							<el-tag size="medium" type="info">{{
								$t("rechargeRecord.cancelled")
							}}</el-tag>
						</template>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination
				background
				layout="total,sizes,prev, pager, next,jumper"
				:current-page="page.pageIndex"
				:total="page.totalSize"
				:page-size="page.pageSize"
				@size-change="sizeChange"
				@current-change="currentChange"
			>
			</el-pagination>
		</div>
	</div>
</template>

<script>
import searchRechargeRecord from "_c/order/SearchRechargeRecord";
import userRecharge from "_c/mywallet/UserRecharge";
import confirmRecharge from "_c/order/ConfirmRecharge";
export default {
	name: "RechargeRecord",
	components: {
		searchRechargeRecord,
		userRecharge,
		confirmRecharge,
	},
	data() {
		return {
			loading: false,
			search: {
				orderNumber: "",
				userName: "",
			},
			page: {
				pageSize: 10,
				pageIndex: 1,
			},
			renewalRecordList: [],
			rentStateList: [],
			renewalPayTypeList: [],
			dialogRecharge: false,
			active: 0,
			selectList: [],
			orderId: "",
			process: "",
			state: "",
			confirmRenew: null,
			dialogRenew: false,
			nickName: "",
			localprice: 0,
		};
	},
	mounted() {
		this.currentChange();
		this.listRechargeStatus();
		this.listRenewalPayType();
	},
	methods: {
		sizeChange(pageSize) {
			this.page.pageSize = pageSize;
			this.currentChange();
		},
		currentChange(pageIndex) {
			this.loading = true;
			this.page.pageIndex = pageIndex ? pageIndex : 1;
			let obj = this.$cloud.objMerge(this.search, this.page);
			this.$api
				.request(this.$url.RechargeRecord.recharge, this.$method.get, obj)
				.then(res => {
					if (res.code === 0) {
						this.renewalRecordList = res.data.records;
						this.page.totalSize = parseInt(res.data.total);
					}
					this.loading = false;
				})
				.catch(() => {
					this.loading = false;
				});
		},
		// 格式化金额
		priceMatter(row) {
			// 截取当前数据到小数点后两位
			let realVal = "";
			if (row.price) {
				realVal = "$" + parseFloat(row.price).toFixed(2);
			}
			return realVal;
		},
		listRechargeStatus() {
			this.$api.dict("gp_renewal_status").then(res => {
				if (res.code === 0) {
					this.rentStateList = res.data;
				}
			});
		},
		listRenewalPayType() {
			this.$api.dict("gp_pay_type").then(res => {
				if (res.code === 0) {
					this.renewalPayTypeList = res.data;
				}
			});
		},
		onSubmit(data) {
			this.search = data;
			this.currentChange();
		},

		resetSearch(data) {
			this.search = data;
			this.currentChange();
		},

		rechargeStatus(row) {
			return this.$cloud.getDictLabel(this.rentStateList, row.state);
		},
		renewalPayType(row) {
			return this.$cloud.getDictLabel(this.renewalPayTypeList, row.payType);
		},
		nextStep(row) {
			this.dialogRecharge = true;
			this.active = parseInt(row.state) >= 2 ? 2 : parseInt(row.state) + 1;
			this.process = parseInt(row.state) >= 2 ? "finish" : "";
			this.state = row.state;
			this.selectList = row.rentEquipment;
			this.orderId = row.id;
			this.confirmRenew = row;
		},

		revoke(row) {
			this.$confirm(
				this.$t("rechargeRecord.revokeRenew"),
				this.$t("common.tip"),
				{
					confirmButtonText: this.$t("common.definite"),
					cancelButtonText: this.$t("common.cancel"),
					type: "warning",
				}
			).then(() => {
				this.$api
					.request(this.$url.RechargeRecord.revokeRecharge, this.$method.post, {
						id: row.id,
					})
					.then(res => {
						if (res.code === 0) {
							this.$notify({
								title: this.$t("common.tip"),
								message: res.msg,
								type: "success",
							});
							this.currentChange();
						}
					});
			});
		},

		cancelRecharge(dialog, state) {
			this.dialogRecharge = dialog;
			if (state) {
				this.currentChange();
			}
		},

		renew(row) {
			this.confirmRenew = row;
			this.dialogRenew = true;
		},

		cancel(dialog, state) {
			this.dialogRenew = dialog;
			if (state) {
				this.currentChange();
			}
		},
	},
};
</script>

<style lang="scss" scoped></style>
